import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';
import {SEARCH_TYPE_MOTOR} from "@services/search-service";
import {Observable} from "rxjs/Observable";

@Component({
  selector: 'app-agris-cantidad-selector',
  templateUrl: './agris-cantidad-selector.component.html',
  styleUrls: ['./agris-cantidad-selector.component.scss', '../agris-common-styles.scss']
})
export class AgrisCantidadSelectorComponent implements OnDestroy {

  @Input() cantidad = 1;
  @Input()
  set _cantidad(val: number) {
    this.cantidad = val;
    this.setupForm();
  }
  @Input() set editable(val: boolean) {
    if (this.form !== null) {
      this.editAllowed = val;
    }
  }

  editAllowed = false;

  @Input() unidad = 'KG'
  @Input() multiplo = 1;
  @Input()
  set _multiplo(val: number) {
    this.multiplo = val;
    this.setupForm();
  }

  @Output() onChange = new EventEmitter<number>();
  @Output() onChangeDebounced = new EventEmitter<number>();


  form: FormGroup = null;

  sub:Subscription = null;
  subDebounce:Subscription = null;

  debounceLastValueSent: number = null;

  constructor(
    private formBuilder: FormBuilder,
  ) {
    this.setupForm();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.subDebounce.unsubscribe();
  }

  setupForm() {
    this.form = this.formBuilder.group({
      cantidad: [this.cantidad, [Validators.required, Validators.min(1), validarMultiplo(this.multiplo)]],
    });
    if (this.sub !== null) {this.sub.unsubscribe();}
    this.sub = this.cantidadCtrl.valueChanges.subscribe(x => {
      // solo cambiamos el valor si el valor elegido es valido
      if (this.cantidadCtrl.valid) {
        this.onChange.emit(Number(this.cantidadCtrl.value));
      }
    });

    this.subDebounce = this.cantidadCtrl.valueChanges
      .debounceTime(750)
      .distinctUntilChanged()
      .subscribe((res: number) => {
        if (res && res.toString().length && this.cantidadCtrl.valid &&
          (this.debounceLastValueSent === null || this.debounceLastValueSent !== this.cantidadCtrl.value)
        ){
          this.debounceLastValueSent = this.cantidadCtrl.value;
          this.onChangeDebounced.emit(Number(this.cantidadCtrl.value))
        }
      });
  }

  modify(value: number) {
    this.cantidad = Math.max(1, this.cantidad + value);
    this.onChange.emit(this.cantidad);
  }

  validateKey(e) {
    // validamos que no se ingrese ni punto ni coma para que no se creen decimales
    if (e.key === '.' || e.key === ',') {
      event.preventDefault();
    }
  }

  get cantidadCtrl(): AbstractControl {
    return this.form.get('cantidad');
  }

  public get valid(): boolean {
    return this.cantidadCtrl.valid;
  }

  public cantidadValue(): number {
    return Number(this.cantidadCtrl.value);
  }
}

function validarMultiplo(multiplo: number): ValidatorFn {
  return function validate(control: AbstractControl) {
    if (control.value !== null && control.value !== undefined && multiplo > 1 && Number(control.value) > 0) {
      const err = {multiplo: true};
      const value = Number(control.value);
      if (value < multiplo) {
        return err;
      }
      // buscamos el modulo del valor para obtener si es divisible (o multiplo) del valor de la unidad
      return (value % multiplo) !== 0 ? err : null;
    }
    return null;
  };
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-cantidad-selector/agris-cantidad-selector.component.ts